module.exports = __webpack_public_path__ + "img/image.2fb1c307.svg";